export default __webpack_public_path__ + "static/portfolio-mas-13-a94fa7f9f4fa760fa54543cede33df61.jpg";